import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/img/all-img/blog-1.png'
import _imports_1 from '../../assets/img/all-img/blog-2.png'
import _imports_2 from '../../assets/img/all-img/blog-3.png'
import _imports_3 from '../../assets/img/all-img/blog-4.png'
import _imports_4 from '../../assets/img/all-img/blog-5.png'
import _imports_5 from '../../assets/img/all-img/blog-6.png'


const _hoisted_1 = { class: "edu-blog-area pt-70 pb-100" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-8" }
const _hoisted_5 = { class: "row justify-content-center" }
const _hoisted_6 = { class: "col-lg-6 col-md-6 col-sm-6" }
const _hoisted_7 = { class: "single-blog-box" }
const _hoisted_8 = { class: "image" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "image"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "cr-tag" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Development")
  ])
], -1)
const _hoisted_11 = { class: "content" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("ul", { class: "cr-items" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "bx bx-user" }),
      /*#__PURE__*/_createElementVNode("span", null, "Admin")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "bx bx-star" }),
    /*#__PURE__*/_createElementVNode("span", null, "Jan 29, 2023")
  ])
], -1)
const _hoisted_13 = { class: "col-lg-6 col-md-6 col-sm-6" }
const _hoisted_14 = { class: "single-blog-box" }
const _hoisted_15 = { class: "image" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "image"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "cr-tag" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Education")
  ])
], -1)
const _hoisted_18 = { class: "content" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("ul", { class: "cr-items" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "bx bx-user" }),
      /*#__PURE__*/_createElementVNode("span", null, "Admin")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "bx bx-star" }),
    /*#__PURE__*/_createElementVNode("span", null, "Jan 29, 2023")
  ])
], -1)
const _hoisted_20 = { class: "col-lg-6 col-md-6 col-sm-6" }
const _hoisted_21 = { class: "single-blog-box" }
const _hoisted_22 = { class: "image" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "image"
}, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "cr-tag" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Education")
  ])
], -1)
const _hoisted_25 = { class: "content" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("ul", { class: "cr-items" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "bx bx-user" }),
      /*#__PURE__*/_createElementVNode("span", null, "Admin")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "bx bx-star" }),
    /*#__PURE__*/_createElementVNode("span", null, "Jan 29, 2023")
  ])
], -1)
const _hoisted_27 = { class: "col-lg-6 col-md-6 col-sm-6" }
const _hoisted_28 = { class: "single-blog-box" }
const _hoisted_29 = { class: "image" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "image"
}, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "cr-tag" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Education")
  ])
], -1)
const _hoisted_32 = { class: "content" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("ul", { class: "cr-items" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "bx bx-user" }),
      /*#__PURE__*/_createElementVNode("span", null, "Admin")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "bx bx-star" }),
    /*#__PURE__*/_createElementVNode("span", null, "Jan 29, 2023")
  ])
], -1)
const _hoisted_34 = { class: "col-lg-6 col-md-6 col-sm-6" }
const _hoisted_35 = { class: "single-blog-box" }
const _hoisted_36 = { class: "image" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "image"
}, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "cr-tag" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Education")
  ])
], -1)
const _hoisted_39 = { class: "content" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("ul", { class: "cr-items" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "bx bx-user" }),
      /*#__PURE__*/_createElementVNode("span", null, "Admin")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "bx bx-star" }),
    /*#__PURE__*/_createElementVNode("span", null, "Jan 29, 2023")
  ])
], -1)
const _hoisted_41 = { class: "col-lg-6 col-md-6 col-sm-6" }
const _hoisted_42 = { class: "single-blog-box" }
const _hoisted_43 = { class: "image" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "image"
}, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "cr-tag" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Education")
  ])
], -1)
const _hoisted_46 = { class: "content" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("ul", { class: "cr-items" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "bx bx-user" }),
      /*#__PURE__*/_createElementVNode("span", null, "Admin")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "bx bx-star" }),
    /*#__PURE__*/_createElementVNode("span", null, "Jan 29, 2023")
  ])
], -1)
const _hoisted_48 = /*#__PURE__*/_createStaticVNode("<div class=\"col-lg-12 col-md-12 col-sm-12\"><div class=\"pagination-area text-center\"><a href=\"#\" class=\"prev page-numbers\"><i class=\"bx bx-chevrons-left\"></i></a><span class=\"page-numbers current\" aria-current=\"page\">1</span><a href=\"#\" class=\"page-numbers\">2</a><a href=\"#\" class=\"page-numbers\">3</a><a href=\"#\" class=\"page-numbers\">4</a><a href=\"#\" class=\"next page-numbers\"><i class=\"bx bx-chevrons-right\"></i></a></div></div>", 1)
const _hoisted_49 = { class: "col-lg-4 col-md-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SideBar = _resolveComponent("SideBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_router_link, {
                    to: "/blog-details",
                    class: "d-block"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }),
                  _hoisted_10
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("h3", null, [
                    _createVNode(_component_router_link, { to: "/blog-details" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Financial Security Thinking and Principles Theory")
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_router_link, {
                    class: "blog-btn",
                    to: "/blog-details"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Read More")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_router_link, {
                    to: "/blog-details",
                    class: "d-block"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  }),
                  _hoisted_17
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("h3", null, [
                    _createVNode(_component_router_link, { to: "/blog-details" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Professional Ceramic Moulding for Beginners ")
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_router_link, {
                    class: "blog-btn",
                    to: "/blog-details"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Read More")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_router_link, {
                    to: "/blog-details",
                    class: "d-block"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_23
                    ]),
                    _: 1
                  }),
                  _hoisted_24
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("h3", null, [
                    _createVNode(_component_router_link, { to: "/blog-details" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Education Is About Create Leaders For Tomorrow ")
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_router_link, {
                    class: "blog-btn",
                    to: "/blog-details"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Read More")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_router_link, {
                    to: "/blog-details",
                    class: "d-block"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_30
                    ]),
                    _: 1
                  }),
                  _hoisted_31
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("h3", null, [
                    _createVNode(_component_router_link, { to: "/blog-details" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Education Is About Create Leaders For Tomorrow ")
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_router_link, {
                    class: "blog-btn",
                    to: "/blog-details"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Read More")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createVNode(_component_router_link, {
                    to: "/blog-details",
                    class: "d-block"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_37
                    ]),
                    _: 1
                  }),
                  _hoisted_38
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _hoisted_40,
                  _createElementVNode("h3", null, [
                    _createVNode(_component_router_link, { to: "/blog-details" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Professional Ceramic Moulding for Beginners ")
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_router_link, {
                    class: "blog-btn",
                    to: "/blog-details"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Read More")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createVNode(_component_router_link, {
                    to: "/blog-details",
                    class: "d-block"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_44
                    ]),
                    _: 1
                  }),
                  _hoisted_45
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _hoisted_47,
                  _createElementVNode("h3", null, [
                    _createVNode(_component_router_link, { to: "/blog-details" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Professional Mobile Painting and Sculpting ")
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_router_link, {
                    class: "blog-btn",
                    to: "/blog-details"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Read More")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _hoisted_48
          ])
        ]),
        _createElementVNode("div", _hoisted_49, [
          _createVNode(_component_SideBar)
        ])
      ])
    ])
  ]))
}